import React, {Suspense} from "react";
import {useSelector} from 'react-redux';
import {useState} from 'react';

//components
import CollapseTab from '../../components/Tabs/CollapseTab';
import StatusIcon from '../../components/Icons/StatusIcon';
import Loading from "../../components/Loading/Loading";

//assets
import icon1 from '../../assets/icons/sections/sit_vehiculo.svg';


export default () => {
    const VehicleSituationContainer = React.lazy(() => import('./components/VehicleSituationContainer'));
    const [show, setShow] = useState(false);
    let boxData = useSelector(state => state.app.data);
    boxData = boxData && boxData.situacionvehiculo;

    return (
        <div onClick={() => setShow(!show)}  className="VehicleSituationSection" id="situacionvehiculo">
            {
                boxData &&
                <CollapseTab
                    sectionName="situacionvehiculo"
                    carouselLength={boxData.body && boxData.body.data && Array.isArray(boxData.body.data) ? boxData.body.data.length : 0}
                    icon={icon1}
                    stateIcon={<StatusIcon
                        status={boxData.body && boxData.body.result && boxData.body.result.type}/>}
                    nav={<div
                        className="font-roboto font-bold font-14 txt-blue line-1-2">{boxData.header.title}</div>}>
                    <div onClick={(e) => e.stopPropagation()}>
                        <Suspense fallback={<Loading size='medium'/>}>
                            {show && <VehicleSituationContainer boxData={boxData}/>}
                        </Suspense>
                    </div>
                </CollapseTab>
            }
        </div>
    )
}
